import React from 'react';

export const pageLabelStyle = {
  display: 'flex',
  alignItems: 'center',
  fontWeight: 700,
  flexShrink: 0,
};

export const PageLabel = ({ children, showSeparator = true }) => (
  <div style={pageLabelStyle}>
    <div className="title">{children}</div>
    {showSeparator && <span className="toolbar-separator" />}
  </div>
);
